<template>
  <div class="changeTeamName">
    <van-field
      class="input"
      clearable
      v-model="teamName"
      placeholder="请输入团队名称~"
    />
    <div class="btn" @click="sumbit">保存</div>
  </div>
</template>

<script>
import { Field, Toast } from "vant";
export default {
  name: "MyTeamChangeName",
  components: {
    [Field.name]: Field
  },
  data() {
    return {
      teamName: ""
    };
  },
  methods: {
    /**
     * 保存
     */
    sumbit() {
      if (this.teamName == "") {
        Toast({ message: "请输入团队名称" });
        return;
      }
      Toast({ message: "修改成功" });
      this.$router.replace({ name: "MyTeam" });
    }
  }
};
</script>

<style lang="scss" scoped>
.changeTeamName {
  .input {
    margin-top: 0.2rem;
  }
  .btn {
    height: 0.8rem;
    line-height: 0.8rem;
    margin: 0.2rem 0.3rem 0 0.3rem;
    background: #ff410a;
    color: #ffffff;
    text-align: center;
    border-radius: 0.1rem;
  }
}
</style>
